/* eslint-disable operator-linebreak */
/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import PerfectScrollbar from 'react-perfect-scrollbar';
import TablePagination from '@mui/material/TablePagination';
import { CSVLink } from 'react-csv';
import Snackbar from '@mui/material/Snackbar';
import EditIcon from '@mui/icons-material/Edit';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Modal,
  Typography,
  Button,
  TableContainer,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  Alert
} from '@material-ui/core';

import Loader from 'react-loader-spinner';
import Grid from '@mui/material/Grid';
import { makeStyles } from '@mui/styles';
import { URL } from '../../utils/factory';

const axios = require('axios');
const useStyles = makeStyles({
  root: {
    backgroundColor: '#000',
    color: '#fff',
    padding: '10px',
    border: 'none',
    borderRadius: '5px',
    textTransform: 'uppercase',
    fontWeight: 'bold'
  }
});

const styletable = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 1350,
  bgcolor: 'white',
  border: '2px solid #fff',
  boxShadow: 24,
  p: 4
};

const invoicedetail = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  bgcolor: 'white',
  border: '2px solid #fff',
  boxShadow: 24,
  padding: '5px 27px 15px 11px'
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 700,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4
};

const istyle = {
  color: 'red'
};

const csvbutton = {
  color: '#ffffff',
  display: 'block',
  width: '131px',
  height: '37px',
  textAlign: 'center',
  paddingTop: '6px',
  borderRadiusr: '4px',
  position: 'relative',
  backgroundColor: '#000000',
  boxShadow: '0 0 1px 0 rgb(0 0 0 / 31%), 0 2px 2px -2px rgb(0 0 0 / 25%)',
  fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
  fontWeight: '500',
  fontSize: '0.875rem',
  lineHeight: '1.75',
  letterSpacing: '0.02857em',
  textTransform: 'uppercase'
};
const CustomerListResults = ({
  customers,
  flagstatus,
  fromdate,
  todate,
  datesearch,
  loaderflag,
  exportlist,
  handleExportGrid,
  exportflag,
  handleExportGridTwo,
  exportlisttwo,
  exportflagver,
  exportflagverCSV,
  handelCsvButon,
  invoicelistexportcsv,
  ...rest
}) => {
  const navigate = useNavigate();
  const [invoicelist, setInvoicelList] = useState([]);
  const [openview, setOpenView] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openEditFirst, setOpenEditFirst] = useState(false);
  const hide = false;
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [page, setPage] = useState(0);
  const [rowsPerPageTwo, setRowsPerPageTwo] = useState(20);
  const [pageTwo, setPageTwo] = useState(0);
  const [responseExcelList, setResponseExcelList] = useState([]);
  const [deliveryEditData, setDeliveryEditData] = useState([]);
  const [invoiceAmount, setInvoiceAmount] = useState('');
  const [invoiceDate, setInvoiceDate] = useState('');
  const [editInvoiceData, setEditInvoiceData] = useState('');
  const [editInvoiceDate, setChangeDripdownValue] = useState('');
  const [dropDownData, setDropDownData] = useState(null);
  const [sneakOpen, setSneakOpen] = useState(false);
  const [sneakOpenFrComment, setSneakOpenFrComment] = useState(false);
  const [sneakBarMessage, setSneakBarMessage] = useState('');
  const [insertPrice, setInsertPrice] = useState('');
  const [invoiceDetailSno, setInvoiceDetailSno] = useState('');
  const [invoiceStatus, setInvoiceStatus] = useState('');
  const [invremarks, setInvRemarks] = useState('');
  const [openRemarkPopup, setOpenRemarkPopup] = useState(false);
  const classes = useStyles();
  const [commentInvoice, SetCommentInvoice] = useState('');
  const [commentDate, setCommentDate] = useState('');
  const [errormsg, setErrorMsg] = useState(false);
  const [sneakBarCommentMessage, setSneakBarCommentMessage] = useState('');
  const [responseForComment, setResponseForComment] = useState([]);
  const [commentStatus, setCommentStatus] = useState('');
  const [loaderstate, setLoaderstate] = useState(false);
  const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
  const [loader, setLoader] = useState(true);
  const [singleselectinv, setSingleSelectInv] = useState('0');
  const [openunchecked, setOpenUnchecked] = useState(false);


  const handleClose = () => {
    setErrorMsg(false);
    setResponseForComment([]);
    setEditInvoiceData('');
    setInvoiceDate('');
    setInvoiceAmount('');
    setInvoiceStatus('');
    setOpenView(false);
    setOpenEdit(false);
    setOpenEditFirst(false);
    setOpenRemarkPopup(false);
  };

  const handleCloseSneakBar = () => {
    setSneakOpen(false);
  };

  const handleCloseCommentSneakbar = () => {
    setSneakOpenFrComment(false);
  };

  const handleCloseSecondPopup = () => {
    setOpenEdit(true);
  };

  const handleUncheckedSingle = (event, invoiceidsingle) => {
    setSingleSelectInv(invoiceidsingle);
    setOpenUnchecked(true);
  };

  useEffect(() => {
    if (flagstatus) {

      customers.forEach(el => {
        el.downloadStatus = 0;
      });

      setInvoicelList(customers);
      setRowsPerPage(20);
      setPage(0);
    } else {
      //  readData();
    }
  }, [customers, flagstatus]);

  useEffect(() => {
    setLoaderstate(loaderflag);
  }, [loaderflag]);

  useEffect(() => {
    setRowsPerPageTwo(20);
    setPageTwo(0);
  }, [responseExcelList]);

  const handleChangeselect = (event) => {
    const data = event.target.value;
    setChangeDripdownValue(event.target.value);
    if (data === 0) {
      setDropDownData('Cancellation');
    }
    if (data === 1) {
      setDropDownData('Other');
    }
    if (data === 2) {
      setDropDownData('Assembly');
    }
    if (data === 3) {
      setDropDownData('Rubbish Removal');
    }
  };

  const handlebetaversiontwo = (sno) => {
    console.log("its working on data", sno);

    invoicelist.forEach(el => {
      el.downloadStatus = 0
      if (el.t1 == sno) {
        el.downloadStatus = 1
      }
    })


    handleExportGridTwo(sno);
  };

  const handleInsertPrice = (event) => {
    const regularExpression = /^[0-9\b]+$/;

    if (
      // eslint-disable-next-line operator-linebreak
      event.target.value === '' ||
      regularExpression.test(event.target.value)
    ) {
      setInsertPrice(event.target.value);
    }
  };

  const handleComments = (inv) => {
    const clientId = localStorage.getItem('tranuserid');

    try {
      axios
        .post(`${URL}sExtraComment`, {
          invoiceno: inv,
          description: '',
          qtype: 6,
          ddate: '',
          Userid: clientId,

          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
          }
        })
        .then((response) => {
          console.log('hello i am herer', response.data.d);
          setResponseForComment(JSON.parse(response.data.d));
        })
        .catch((error) => {
          console.log('API error', error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleCommentPopup = (event, inv, date, status) => {
    setCommentStatus(status);
    setOpenRemarkPopup(true);
    SetCommentInvoice(inv);
    setCommentDate(date);
    handleComments(inv);
  };

  const handleRemarksChange = (event) => {
    if (event.target.value.length > 0) setErrorMsg(false);
    setInvRemarks(event.target.value.trim());
  };

  const handleRemarks = () => {
    const clientId = localStorage.getItem('tranuserid');
    setErrorMsg(false);

    if (invremarks === '') {
      setErrorMsg(true);
    } else {
      try {
        axios
          .post(`${URL}sExtraComment`, {
            invoiceno: commentInvoice,
            description: invremarks,
            qtype: 5,
            ddate: commentDate,
            Userid: clientId,

            headers: {
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
            }
          })
          .then((response) => {
            console.log('hello i am herer', response);
            setSneakOpenFrComment(true);
            setSneakBarCommentMessage('Comment saved successfully');
            setOpenRemarkPopup(false);
            SetCommentInvoice('');
            setCommentDate('');
            setInvRemarks('');
            setErrorMsg(false);
          })
          .catch((error) => {
            console.log('API error', error);
          });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleExportClick = () => {
    handleExportGrid();
  };

  useEffect(() => {
    if (exportlisttwo.length > 0) {
      setLoader(false);
    }
  }, [exportlisttwo]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleInvoiceDetailChangePage = (event, newPage) => {
    setPageTwo(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleInvoiceDetailChangeRowsPerPage = (event) => {
    // eslint-disable-next-line radix
    setRowsPerPageTwo(parseInt(event.target.value, 10));
    setPageTwo(0);
  };

  const handleViewInvoice = async (sno, date) => {
    await setInvoiceDetailSno(sno);
    await localStorage.setItem("InvoiceSno", sno);
    await localStorage.setItem("settlementDate", date);
    navigate('/app/invoicedetailpage', { replace: true });
  };

  const handleAddNewExtraCharges = () => {
    navigate('/app/addnewextracharges', { replace: true });
  }

  const handleDeliveryListData = (invoicedata, date) => {
    try {
      axios
        .post(`${URL}ViewExtraCharge`, {
          invoiceno: invoicedata && invoicedata ? invoicedata : editInvoiceData,
          ddate: invoiceDate && invoiceDate ? invoiceDate : date,
          qtype: '2',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
          }
        })
        .then((response) => {
          if (response.data.d !== '') {
            const responseData = JSON.parse(response.data.d);
            setDeliveryEditData(responseData);
          } else setDeliveryEditData([]);
        })
        .catch((error) => {
          console.log('API error', error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleSaveInovice = (inv, date) => {
    try {
      axios
        .post(`${URL}sTrnasinvoivemain`, {
          invoiceno: inv,
          fdate: date,
          qtype: '1',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
          }
        })
        .then(() => {
          console.log('Inside save Invoice');
        })
        .catch((error) => {
          console.log('API error', error);
        });
    } catch (errorMessage) {
      console.log('Error inside handle save invoice', errorMessage);
    }
  };

  const handleDeleteData = (data) => {
    try {
      axios
        .post(`${URL}DeleteExtraCharge`, {
          invoiceno: editInvoiceData && editInvoiceData,
          qtype: '4',
          uniq_id_ec: data.sno,
          settlementid: invoiceDetailSno,
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
          }
        })
        .then(() => {
          handleDeliveryListData();
        })
        .catch((error) => {
          console.log('API error', error);
        });
    } catch (errorMessage) {
      console.log('Error message in delete method', errorMessage);
    }
  };

  const handleInserNewData = async () => {
    if (editInvoiceDate === '') {
      setSneakOpen(true);
      setSneakBarMessage('Please select Dropdown value');
    } else if (insertPrice === '') {
      setSneakOpen(true);
      setSneakBarMessage('Please enter amount');
    } else {
      axios
        .post(`${URL}sExtraCharge`, {
          invoiceno: editInvoiceData,
          description: dropDownData,
          amount: insertPrice,
          ddate: invoiceDate && invoiceDate,
          code: editInvoiceDate,
          uniq_id_ec: '',
          qtype: '1',
          settlementid: invoiceDetailSno,
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
          }
        })
        .then(() => {
          setInsertPrice('');
          setChangeDripdownValue('');
          setSneakBarMessage('');
          // eslint-disable-next-line no-use-before-define
          handleDeliveryListData();
        })
        .catch((error) => {
          console.log('API error', error);
        });
    }
  };



  const handleConfirmEditExcel = (data) => {
    try {
      axios
        .post(`${URL}sTrnasinvoivemain`, {
          invoiceno: data.Inv_id,
          qtype: '2',
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': "'POST','OPTIONS','GET'"
          }
        })
        .then(() => {
          setOpenEditFirst(false);
          setInvoiceStatus('');
          handleViewInvoice(invoiceDetailSno);
        })
        .catch((error) => {
          console.log('API error', error);
        });
    } catch (errorMessage) {
      console.log('Error inside handle save invoice', errorMessage);
    }
  };


  const handleSelectAll = (event) => {
    let newSelectedCustomerIds;
    if (event.target.checked) {
      newSelectedCustomerIds = invoicelist.map((customer) => customer.inv_id);
      setSelectedCustomerIds(newSelectedCustomerIds);
      for (let i = 0; i < newSelectedCustomerIds.length; i++) {
        for (let z = 0; z < invoicelist.length; z++) {
          if (invoicelist[z].inv_id === newSelectedCustomerIds[i]) {
            invoicelist[z].Itd_IsTransBooked = 'Booked';
            invoicelist[z].chkTransBooked = 'Yes';
          }
        }
      }
    } else {
      newSelectedCustomerIds = [];
      setSelectedCustomerIds(newSelectedCustomerIds);

      for (let z = 0; z < invoicelist.length; z++) {
        invoicelist[z].Itd_IsTransBooked = invoicelist[z].Itd_IsTransBookedold;
        invoicelist[z].chkTransBooked = invoicelist[z].chkTransBookedold;
      }

    }
  };

  const handleSelectSingle = (event, invoiceidsingle) => {
    let newSelectedCustomerIds;
    console.log('Prev Invoice:::::::::::', invoiceidsingle);
    if (event.target.checked) {
      newSelectedCustomerIds = invoicelist.map((customer) => customer.inv_id);
      setSelectedCustomerIds(newSelectedCustomerIds);
      for (let i = 0; i < newSelectedCustomerIds.length; i++) {
        for (let z = 0; z < invoicelist.length; z++) {
          if (
            // eslint-disable-next-line operator-linebreak
            invoicelist[z].inv_id === newSelectedCustomerIds[i] &&
            invoicelist[z].inv_id === invoiceidsingle
          ) {
            invoicelist[z].chkTransBooked = 'Yes';
            invoicelist[z].Itd_IsTransBooked = 'Booked';
          }
        }
      }
    } else {
      newSelectedCustomerIds = [];
      setSelectedCustomerIds(newSelectedCustomerIds);


      for (let z = 0; z < invoicelist.length; z++) {
        if (invoicelist[z].inv_id === invoiceidsingle) {
          // eslint-disable-next-line operator-linebreak
          invoicelist[z].Itd_IsTransBooked =
            invoicelist[z].Itd_IsTransBookedold;
          invoicelist[z].chkTransBooked = invoicelist[z].chkTransBookedold;
        }
      }

    }
  };

  const handleOpenEdit = (inv, date, amount, status) => {
    setInvoiceStatus(status);
    setInvoiceAmount(amount);
    setInvoiceDate(date);
    setOpenEdit(false);
    handleSaveInovice(inv, date);
    setOpenEditFirst(true);
    setEditInvoiceData(inv);
    handleDeliveryListData(inv, date);
  };

  return (
    <Card {...rest}>
      <PerfectScrollbar>
        <Box sx={{ flexGrow: 1 }} style={{ display: 'block' }}>
          <Grid
            container
            spacing={2}
            style={{ marginTop: '10px', paddingLeft: '10px' }}
          >
            <Grid item xs={10}>
              <h2>Invoice List </h2>
            </Grid>

            {/* <Grid item xs={2}>
              <Button variant="contained"
                onClick={handleAddNewExtraCharges}
              >
                View Extra Charges
              </Button>
            </Grid> */}

            {hide && (
              <Grid item xs={1}>
                {exportflag && (
                  <Button variant="contained" onClick={handleExportClick}>
                    Export
                  </Button>
                )}
                {!exportflag && (
                  <ReactHTMLTableToExcel
                    color="primary"
                    table="emp1"
                    filename="ReportExcel"
                    sheet="sheet"
                    buttonText="Download"
                    className={classes.root}
                  />
                )}
              </Grid>
            )}

            {hide && (
              <Grid item xs={1.3}>
                {exportflagver && (
                  <Button variant="contained" onClick={handlebetaversiontwo}>
                    Export (Beta)
                  </Button>
                )}
                {!exportflagver && (
                  <ReactHTMLTableToExcel
                    color="primary"
                    table="emp2"
                    filename="ReportExcel"
                    sheet="sheet"
                    buttonText="Download"
                    className={classes.root}
                  />
                )}
              </Grid>
            )}

            {hide && (
              <Grid item xs={1.5}>
                {exportflagverCSV && (
                  <Button variant="contained" onClick={handelCsvButon}>
                    Export (Csv)
                  </Button>
                )}
                {!exportflagverCSV && (
                  <CSVLink style={csvbutton} data={invoicelistexportcsv}>
                    Download CSV
                  </CSVLink>
                )}
              </Grid>

            )}

            <Loader
              visible={loaderstate}
              type="Puff"
              color="#00BFFF"
              height={45}
              width={45}
              timeout={300000}
            />

            <Box
              sx={{ flexGrow: 1 }}
              style={{
                marginTop: '24px',
                fontWeight: 'bolder',
                color: 'red'
              }}
            >
              {loaderstate === false && invoicelist && invoicelist.length === 0
                ? 'Sorry there is no records'
                : ''}
            </Box>

          </Grid>
        </Box>

        <Box sx={{ minWidth: 1350 }}>
          <Table id="emp">
            <TableHead>
              <TableRow>
                <TableCell>Settlement No</TableCell>
                <TableCell>Delivery Company</TableCell>
                <TableCell> Date</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell> Extra Charges</TableCell>
                <TableCell>Unconfirmed</TableCell>
                <TableCell>Confirmed</TableCell>
                <TableCell>Approved</TableCell>
                <TableCell>Total Job</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>View</TableCell>
                <TableCell>E-Settlement</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invoicelist
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((customer) => (
                  <TableRow hover>
                    <TableCell>{customer.t1}</TableCell>
                    <TableCell>{customer.DeliveryCompany}</TableCell>
                    <TableCell> {customer.dates}</TableCell>
                    <TableCell>{`$ ${customer.Total_Amount}`}</TableCell>
                    <TableCell>{`$ ${customer.Extra_Amount}`}</TableCell>
                    <TableCell> {customer.uncorm}</TableCell>
                    <TableCell> {customer.waiting}</TableCell>
                    <TableCell> {customer.app}</TableCell>
                    <TableCell> {customer.totjobs}</TableCell>
                    <TableCell>{customer.status}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        onClick={
                          () =>
                            // eslint-disable-next-line implicit-arrow-linebreak
                            handleViewInvoice(customer.t1, customer.dates)
                          // eslint-disable-next-line react/jsx-curly-newline
                        }
                      >
                        View
                      </Button>
                    </TableCell>

                    <TableCell>
                      {/* {exportflagver && ( */}

                      {customer.downloadStatus == 0 && (

                        <Button variant="contained" onClick={() => handlebetaversiontwo(customer.t1)}>
                          E-Settlement
                        </Button>
                      )}
                      {/* {!exportflagver && ( */}

                      {customer.downloadStatus == 1 && loader == false && (
                        <ReactHTMLTableToExcel
                          color="primary"
                          table="emp2"
                          filename="ReportExcel"
                          sheet="sheet"
                          buttonText="Download"
                          className={classes.root}
                        />
                      )}

                      {customer.downloadStatus == 1 && loader && (
                        <ReactHTMLTableToExcel
                          disabled
                          color="primary"
                          filename="ReportExcel"
                          sheet="sheet"
                          buttonText="Wait.."
                          className={classes.root}
                        />
                      )}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>

            <TableRow>
              <TableCell colSpan={11}>
                <TablePagination
                  rowsPerPageOptions={[20, 50, 100, 200]}
                  component="div"
                  count={invoicelist.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableCell>
            </TableRow>
          </Table>

          <table
            id="emp2"
            style={{ display: 'none' }}
            cellSpacing="5"
            cellPadding="5"
          >
            <thead>
              <tr bgcolor="skyblue" style={{ border: '1px solid black' }}>
                <th>Invoice No</th>
                <th>Delivery Date</th>
                <th>Customer Details</th>
                <th>Status</th>
                <th>Amount</th>
                <th>Extra Charge Amount</th>
                <th>Delivery Type</th>
                <th>DeliveryCompany</th>
                <th>settlement Id</th>
                <th>Extra Charges</th>
                <th>Comments</th>
              </tr>
            </thead>
            <tbody>
              {exportlisttwo.map((customer, i) => (
                <tr key={i}>
                  <td>{customer.InvoiceNo}</td>
                  <td>{customer.DeliveryDate}</td>
                  <td>{customer.Customer_Details}</td>
                  <td>{customer.Status}</td>
                  <td>{customer.Amount}</td>
                  <td>{customer.ExtrachargesAmount}</td>
                  <td>{customer.Delivery_Type}</td>
                  <td>{customer.delivery_Company}</td>
                  <td>{customer.settlementid}</td>
                  <td>{customer.Extra_charges}</td>
                  <td>{customer.Comments}</td>
                </tr>
              ))}
            </tbody>
          </table>

        </Box>
      </PerfectScrollbar>

      {/* view data model */}
      <Modal
        open={openview}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        contentStyle={{ width: '800%', maxWidth: 'none' }}
      >
        <Box sx={styletable}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Preview
            </Typography>
          </div>

          <Typography
            id="modal-modal-footer"
            sx={{ mt: 10 }}
            style={{ textAlign: 'center' }}
          >
            {/* <Typography id="modal-modal-title" variant="h6" component="h2">
              {success ? 'Data Saved successfully' : null}
            </Typography> */}
            <Button
              variant="outlined"
              style={{ margin: '0px 4px 0px 0px' }}
              onClick={handleClose}
            >
              CANCEL
            </Button>
            <Button variant="contained">CONFIRM</Button>
          </Typography>
        </Box>
      </Modal>

      {/* Edit Invoice */}
      <Modal
        open={openEdit}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        contentStyle={{ width: '800%', maxWidth: 'none' }}
      >
        <Box sx={invoicedetail}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ paddingTop: 8 }}
            >
              Invoice Detail
            </Typography>
          </div>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Box sx={{ minWidth: 550 }}>
              <TableContainer sx={{ maxHeight: 550 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Invoice No</TableCell>
                      <TableCell>Details</TableCell>
                      <TableCell>Amount($)</TableCell>
                      <TableCell>Total Extra Charges</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell> Comment </TableCell>
                      <TableCell> Confirm</TableCell>
                      <TableCell> Extra Charges </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {responseExcelList
                      .slice(
                        pageTwo * rowsPerPageTwo,
                        pageTwo * rowsPerPageTwo + rowsPerPageTwo
                      )
                      .map((customer, index) => (
                        <TableRow hover key={index[0]}>
                          <TableCell> {customer.Inv_id} </TableCell>
                          <TableCell>
                            {customer.inv_address}
                            <br />
                            {customer.inv_email}
                            <br />
                            {customer.inv_mobile && (
                              <>
                                {customer.inv_mobile} <br />
                              </>
                            )}
                            {customer.Inv_phone && (
                              <>
                                {customer.Inv_phone}
                                <br />
                              </>
                            )}
                            {customer.inv_state}
                          </TableCell>
                          <TableCell> {customer.Inv_delcharge} </TableCell>
                          <TableCell> {customer.Total_Extracharge} </TableCell>
                          <TableCell> {customer.Status} </TableCell>
                          <TableCell> {customer.DeliveryDate} </TableCell>
                          <TableCell>
                            <EditIcon
                              onClick={
                                (event) =>
                                  // eslint-disable-next-line implicit-arrow-linebreak
                                  handleCommentPopup(
                                    event,
                                    customer.Inv_id,
                                    customer.DeliveryDate,
                                    customer.Status
                                  )
                                // eslint-disable-next-line react/jsx-curly-newline
                              }
                            />
                          </TableCell>
                          <TableCell>
                            {customer.Status === 'Unconfirmed' ? (
                              <Button
                                variant="contained"
                                color="primary"
                                size="medium"
                                onClick={() => handleConfirmEditExcel(customer)}
                              >
                                Confirm
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                color="primary"
                                size="medium"
                                disabled
                                onClick={() => handleConfirmEditExcel(customer)}
                              >
                                Confirm
                              </Button>
                            )}
                          </TableCell>

                          <TableCell>
                            {customer.Status !== 'Unconfirmed' ? (
                              <Button
                                variant="contained"
                                color="primary"
                                size="medium"
                                onClick={
                                  () =>
                                    // eslint-disable-next-line implicit-arrow-linebreak
                                    handleOpenEdit(
                                      customer.Inv_id,
                                      customer.DeliveryDate,
                                      customer.Inv_delcharge,
                                      customer.Status
                                    )
                                  // eslint-disable-next-line react/jsx-curly-newline
                                }
                              >
                                View
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                color="primary"
                                size="medium"
                                // disabled={
                                //   customer.Status !== 'Pending' ? 'true' : 'false'
                                // }
                                onClick={
                                  () =>
                                    // eslint-disable-next-line implicit-arrow-linebreak
                                    handleOpenEdit(
                                      customer.Inv_id,
                                      customer.DeliveryDate,
                                      customer.Inv_delcharge,
                                      customer.Status
                                    )
                                  // eslint-disable-next-line react/jsx-curly-newline
                                }
                              >
                                Extra Charges
                              </Button>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>

                  <TableRow>
                    <TableCell colSpan={10}>
                      <TablePagination
                        rowsPerPageOptions={[20, 50, 100, 200]}
                        component="div"
                        count={responseExcelList.length}
                        rowsPerPage={rowsPerPageTwo}
                        page={pageTwo}
                        onPageChange={handleInvoiceDetailChangePage}
                        onRowsPerPageChange={
                          handleInvoiceDetailChangeRowsPerPage
                        }
                      />
                    </TableCell>
                  </TableRow>
                </Table>
              </TableContainer>
            </Box>
          </Typography>

          <Typography
            id="modal-modal-footer"
            sx={{ mt: 2 }}
            style={{ textAlign: 'center' }}
          >
            <Button
              variant="outlined"
              style={{ margin: '0px 4px 0px 0px' }}
              onClick={handleClose}
            >
              CLOSE
            </Button>
          </Typography>
        </Box>
      </Modal>

      {/*  Edit Extra Charges */}
      <Modal
        open={openEditFirst}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        contentStyle={{
          width: '800%',
          maxWidth: 'none',
          backgroundColor: '#dcdcdc'
        }}
      >
        <Box sx={styletable} className="InvoicePopup">
          <Typography id="modal-modal-title" variant="h5" component="h5">
            Invoice No. {editInvoiceData}
          </Typography>
          <div className="SectionOne">
            <Typography id="modal-modal-title" variant="h3" component="h3">
              Delivery charge amount
            </Typography>
            <Typography id="modal-modal-title" variant="h3" component="h3">
              {invoiceAmount && invoiceAmount}
            </Typography>
          </div>

          <Box sx={{ minWidth: 550 }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                backgroundColor: '#fff',
                padding: '20px 20px'
              }}
            >
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    {invoiceStatus && invoiceStatus === 'Unconfirmed' ? (
                      <FormControl fullWidth size="small">
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ margin: '0px 0px 0px 32px' }}
                        >
                          Select value
                        </InputLabel>

                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={editInvoiceDate}
                          label="Select value"
                          onChange={handleChangeselect}
                        >
                          <MenuItem value={2}>Assembly</MenuItem>
                          <MenuItem value={0}>Cancellation</MenuItem>
                          <MenuItem value={1}>Other</MenuItem>
                          <MenuItem value={3}>Rubbish Removal</MenuItem>
                        </Select>
                      </FormControl>
                    ) : (
                      <FormControl fullWidth size="small" disabled>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ margin: '0px 0px 0px 32px' }}
                        >
                          Select value
                        </InputLabel>

                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={editInvoiceDate}
                          label="Select value"
                          onChange={handleChangeselect}
                        >
                          <MenuItem value={2}>Assembly</MenuItem>
                          <MenuItem value={0}>Cancellation</MenuItem>
                          <MenuItem value={1}>Labour Hire</MenuItem>
                          <MenuItem value={3}>Rubbish Removal</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  </Grid>

                  <Grid item xs={3}>
                    {invoiceStatus && invoiceStatus === 'Unconfirmed' ? (
                      <TextField
                        label="Extra charge amount"
                        size="small"
                        id="outlined-start-adornment"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          )
                        }}
                        placeholder="Amount"
                        value={insertPrice}
                        onChange={handleInsertPrice}
                      />
                    ) : (
                      <TextField
                        label="Extra charge amount"
                        size="small"
                        id="outlined-start-adornment"
                        disabled
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          )
                        }}
                        placeholder="Amount"
                        value={insertPrice}
                        onChange={handleInsertPrice}
                      />
                    )}
                  </Grid>
                  <Grid item xs={2}>
                    <Typography id="modal-modal-footer">
                      {invoiceStatus && invoiceStatus === 'Unconfirmed' ? (
                        <Button
                          variant="contained"
                          onClick={handleInserNewData}
                        >
                          ADD
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          onClick={handleInserNewData}
                          disabled
                        >
                          ADD
                        </Button>
                      )}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </div>
            <TableContainer sx={{ maxHeight: 440 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell>Data</TableCell>
                    <TableCell>Amount($)</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Action</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell> { }</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {deliveryEditData.map((customer) => (
                    <TableRow hover>
                      <TableCell> {customer.Ec_Description} </TableCell>
                      <TableCell> {customer.Ec_Amount} </TableCell>
                      <TableCell> {customer.Column2} </TableCell>
                      <TableCell>
                        {' '}
                        {customer.Status === '1'
                          ? 'Approve'
                          : 'Unapproved'}{' '}
                      </TableCell>

                      <TableCell>
                        {invoiceStatus && invoiceStatus === 'Unconfirmed' ? (
                          <Button
                            variant="contained"
                            color="primary"
                            size="medium"
                            onClick={() => handleDeleteData(customer)}
                          >
                            Delete
                          </Button>
                        ) : (
                          <Button
                            variant="contained"
                            color="primary"
                            size="medium"
                            onClick={() => handleDeleteData(customer)}
                            disabled
                          >
                            Delete
                          </Button>
                        )}
                      </TableCell>
                      <TableCell> { } </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <div className="PopupFooter">
            {invoiceStatus && invoiceStatus === 'Unconfirmed' ? (
              <Button
                variant="outlined"
                style={{ margin: '0px 4px 0px 0px' }}
                onClick={handleCloseSecondPopup}
              >
                OK
              </Button>
            ) : (
              <Button
                variant="outlined"
                style={{ margin: '0px 4px 0px 0px' }}
                onClick={handleCloseSecondPopup}
              >
                CANCEL
              </Button>
            )}
          </div>
        </Box>
      </Modal>

      <Modal
        open={openRemarkPopup}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <TableContainer sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell>Settlement</TableCell>
                  <TableCell>Comments</TableCell>
                  <TableCell>Created By</TableCell>
                  <TableCell>Created Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {responseForComment
                  && responseForComment.length > 0
                  && responseForComment.map((customer) => (
                    <TableRow hover>
                      <TableCell> {customer.sno} </TableCell>
                      <TableCell> {customer.Comment} </TableCell>
                      <TableCell> {customer.createdbyname} </TableCell>
                      <TableCell>{customer.createddate}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {commentStatus && commentStatus === 'Unconfirmed' ? (
              <TextField
                fullWidth
                id="outlined-multiline-static"
                label="Comment"
                multiline
                rows={8}
                defaultValue={invremarks}
                columns={20}
                onChange={handleRemarksChange}
              />
            ) : null}
            {errormsg && (
              <Typography sx={istyle}>Please enter remarks </Typography>
            )}
          </Typography>
          <Typography
            id="modal-modal-footer"
            sx={{ mt: 2 }}
            style={{ textAlign: 'center' }}
          >
            {commentStatus && commentStatus === 'Unconfirmed' ? (
              <Button variant="contained" onClick={handleRemarks}>
                Save Comment
              </Button>
            ) : null}
          </Typography>
        </Box>
      </Modal>

      <Snackbar
        open={sneakOpen}
        autoHideDuration={6000}
        onClose={handleCloseSneakBar}
      >
        <Alert
          onClose={handleCloseSneakBar}
          severity="error"
          sx={{ width: '100%' }}
        >
          {sneakBarMessage && sneakBarMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={sneakOpenFrComment}
        autoHideDuration={6000}
        onClose={handleCloseCommentSneakbar}
      >
        <Alert
          onClose={handleCloseCommentSneakbar}
          severity="success"
          sx={{ width: '100%' }}
        >
          {sneakBarCommentMessage && sneakBarCommentMessage}
        </Alert>
      </Snackbar>
    </Card>
  );
};

CustomerListResults.propTypes = {
  customers: PropTypes.array.isRequired
};

export default CustomerListResults;
